/**
 * @typedef IInitConsultingDoctorData
 * @property { number | null } id -
 * @property { string } fullName -
 * @property { string } imageSrc -
 * @property { string } experience -
 * @property { string } category -
 * @property { string } science -
 *
 * @typedef { IInitConsultingDoctorData[] } TInitConsultingDoctorsData
 */
/** @returns { TInitConsultingDoctorsData } - */
const getInitConsultingDoctorsData = () => []

/**
 * @typedef IConsultingDoctor
 * @property { number | null } id -
 * @property { Date | null } nearestAppointmentDate -
 * @property { string } nearestAppointmentDateString -
 * @property { string } formattedNearestAppointmentDate -
 * @property { IDoctorConsultation[] } consultations -
 *
 * @typedef { IInitConsultingDoctorData & IConsultingDoctor } ISelectedConsultingDoctor
 */
/** @returns { ISelectedConsultingDoctor } - */
const getSelectedConsultingDoctor = () => ({
  id: null,
  fullName: '',
  imageSrc: '',
  experience: '',
  category: '',
  science: '',
  consultations: [],
  nearestAppointmentDate: null,
  nearestAppointmentDateString: '',
  formattedNearestAppointmentDate: '',
  hasAppointmentRestrictions: false,
})

/**
 * @typedef IInitDoctorsConsultationData
 * @property { number | null } id -
 * @property { string } name -
 * @property { string } price -
 *
 * @typedef { IInitDoctorsConsultationData[] } TInitDoctorsConsultationsData
 */
/** @returns { TInitDoctorsConsultationsData } - */
const getInitDoctorsConsultationsData = () => []

/**
 * @typedef IDoctorConsultation
 * @property { number | null } id -
 * @property { Date | null } nearestAppointmentDate -
 * @property { string } nearestAppointmentDateString -
 * @property { string } formattedNearestAppointmentDate -
 *
 * @typedef { IInitDoctorsConsultationData & IDoctorConsultation } ISelectedDoctorConsultation
 */
/** @returns { ISelectedDoctorConsultation } - */
const getSelectedDoctorConsultation = () => ({
  id: null,
  name: '',
  price: '',
  relatedDoctorId: null,
  nearestAppointmentDate: null,
  nearestAppointmentDateString: '',
  formattedNearestAppointmentDate: '',
})

/**
 * @typedef IInitPreliminaryConsultationData
 * @property { boolean } isPreliminaryConsultation -
 * @property { TInitConsultingDoctorsData } initConsultingDoctorsData -
 * @property { TInitDoctorsConsultationsData } initDoctorsConsultationsData -
 */
/** @returns { IInitPreliminaryConsultationData } - */
const getInitPreliminaryConsultationData = () => ({
  isPreliminaryConsultation: false,
  initConsultingDoctorsData: getInitConsultingDoctorsData(),
  initDoctorsConsultationsData: getInitDoctorsConsultationsData(),
})

/**
 * @typedef { IConsultingDoctor[] } TDoctorsAndConsultationsData
 */
/** @returns { TDoctorsAndConsultationsData } - */
const getDoctorsAndConsultationsData = () => []

export {
  getInitConsultingDoctorsData,
  getSelectedConsultingDoctor,
  getInitDoctorsConsultationsData,
  getSelectedDoctorConsultation,
  getInitPreliminaryConsultationData,
  getDoctorsAndConsultationsData,
}
